/**
 * C2C聊天通讯录
 * Bai.Zhiming
 * 2019-7-18
 */
angular.module('C2CDirectoryModule', [])
    . directive('c2cDirectory', ['trsHttpService', '$timeout', '$q', function(trsHttpService, $timeout, $q) {
        return {
            restrict: 'E',
            replace: true,
            scope: false,
            templateUrl: './IM/chatWindow/chatDirectory/C2CDirectory/C2CDirectory_tpl.html',
            link(scope, $element, $attrs) {
                initStatus();
                initData();

                /**
             * [searchUsers description] 搜素用户
             * @param  {[type]} $viewValue [description] 搜索条件
             * @return {[type]}            [description]
             */
                scope.searchUsers = function($viewValue) {
                    if ($viewValue == '' || angular.isObject($viewValue)) {return;}
                    if (scope.status.searchTimer) {
                        $timeout.cancel(scope.status.searchTimer);
                        scope.status.searchTimer = null;
                    }
                    scope.status.searchTimer = $timeout(() => {
                        let params = {
                            Name: $viewValue,
                            methodname: 'searchUserOrDept',
                            serviceid: 'mlf_extuser'
                        };
                        return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                            data = data.filter((item) => item.TYPE != '201');
                            return data;
                        });
                    }, 800);
                    return scope.status.searchTimer;
                };

                /**
             * [description] 监控搜索词变化
             * @return {[type]}                     [description]
             */
                scope.$watch('status.searchUser', (newV, oldV) => {
                    if (!angular.isObject(newV)) {return;}
                    scope.fn.selectInfo(angular.copy(newV));
                });

                /**
             * [getTreeData description] 获取组织树
             * @return {[type]} [description]
             */
                function getTreeData() {
                    let params = {
                        'serviceid': 'mlf_group',
                        'methodname': 'queryGroupTreeWithMyPath'
                    };
                    // 获取没有权限的组织树
                    scope.loaders = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        scope.data.treeData = [data];
                    });
                }

                /**
             * [showToggle description] 展开树节点
             * @param  {[type]} node [description] 被展开节点信息
             * @return {[type]}      [description]
             */
                scope.showToggle = function(node) {
                    if (!angular.isArray(node.CHILDREN) || node.CHILDREN.length === 0) {
                        getUserByGroupId(node).then(() => {
                            childrenTree(node);
                        });
                    }
                };

                /**
             * [showSelected description] 选中某个用户
             * @param  {[type]} node [description]
             * @return {[type]}      [description]
             */
                scope.showSelected = function(node) {
                    if (angular.isFunction(scope.fn.selectInfo)) {
                        scope.fn.selectInfo(angular.copy(node));
                    }
                };

                /**
             * [getUserByGroupId description] 通过组织id获取用户列表
             * @param  {[object]} node [description] 被选中的节点
             * @return {[type]}         [description]
             */
                function getUserByGroupId(node) {
                    let deffer = $q.defer();
                    let params = {
                        GroupId: node.GROUPID,
                        methodname: 'getUsersByGroup',
                        serviceid: 'mlf_group'
                    };
                    // 获取没有权限的组织树
                    scope.loaders = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        node.CHILDREN = data;
                        deffer.resolve();
                    });
                    return deffer.promise;
                }

                /**
             * [childrenTree description] 根据父节点信息获取子节点
             * @param  {[type]}   node     [description]
             * @param  {Function} callback [description]
             * @return {[type]}            [description]
             */
                function childrenTree(node, callback) {
                    var param = {
                        'serviceid': 'mlf_group',
                        'methodname': 'queryChildGroupsWithOutRight',
                        'GroupId': node.GROUPID
                    };
                    scope.loaders = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), param, 'get').then(function(dataC) {
                        node.CHILDREN = node.CHILDREN.concat(dataC.CHILDREN);
                        if (angular.isFunction(callback)) {
                            callback();
                        }
                    });
                }

                /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
                function initStatus() {
                    let status = {
                        searchTimer: '', // 搜索延时器
                        treeOptions: {
                            nodeChildren: 'CHILDREN',
                            dirSelectable: true,
                            allowDeselect: false,
                            injectClasses: {
                                ul: 'a1',
                                li: 'a2',
                                liSelected: 'a7',
                                iExpanded: 'a3',
                                iCollapsed: 'a4',
                                iLeaf: 'a5',
                                label: 'a6',
                                labelSelected: 'a8'
                            },
                            isLeaf: function(node) {
                                return !!node.USERNAME;
                            },
                            isSelectable: function(node) {
                                return !!node.USERNAME; // 非用户节点不能选，当前用户不能选
                            }
                        }
                    };
                    let data = {
                        treeData: [],
                        expandedData: []
                    };
                    angular.extend(scope.status, status);
                    angular.extend(scope.data, data);
                }

                /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
                function initData() {
                    getTreeData();
                }
            }
        };
    }]);
